export default {
  getXmlAudit: (state) => state.xmlAudit,
};
